<template>
  <div>
    <Title :title="$t('ACADEMICO.EXTRA_CLASSE')" />
    <b-row class="d-flex justify-content-end mt-3">
      <b-col>
        <p>
          {{ $t("ACADEMICO.EXTRA_CLASSE_INFO") }}
        </p>
      </b-col>
      <b-col class="text-right" md="12">
        <div class="d-flex gap-2">
          <b-button @click="redirecionarEsporte" variant="info" class="flex-fill">
            {{ $t("ACADEMICO.REDIRECIONAR_ESPORTE") }}
          </b-button>
          <b-button @click="redirecionarCultura" variant="info" class="flex-fill">
            {{ $t("ACADEMICO.REDIRECIONAR_CULTURA") }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Title from "@/components/Title.vue";

export default {
  props: ["dados"],
  components: {
    Title,
  },
  data() {
    return {
      esporteUrl: "https://colegiojaragua.com.br/extraclasse/esporte",
      culturaUrl: "https://colegiojaragua.com.br/extraclasse/cultura",
    };
  },
  methods: {
    redirecionarEsporte() {
      window.open(this.esporteUrl, '_blank');
    },  
    redirecionarCultura() {
      window.open(this.culturaUrl, '_blank');
    },
  },
};
</script>
